import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PercentageCircle from "components/PercentageCircle/PercentageCircle";
import { ModuleStateType } from "utils/constants";

const ProgressIcon = ({
	state,
	ruleType,
	hasContent,
	className,
	progressData,
	handleClick,
	handleOpenLockModal,
	handleOpenCourseTraversalModal
}) => {
	const getProgressString = () => {
		if (progressData.value === 100) {
			return progressData.hasProgress ? "Completed" : "Watched";
		}

		if (!progressData.success) {
			return "Retry";
		}

		if (progressData.value === 0) {
			return "Not started";
		}

		return progressData.asPercentage ? `${progressData.value}%` : "In progress";
	};

	const renderSubmoduleProgress = () => {
		if (state === ModuleStateType.Enabled) {
			if (hasContent) {
				return (
					<div className={className} onClick={() => handleClick()}>
						<PercentageCircle progress={progressData.value} visited={!progressData.success} />
						<p className="small-text">{getProgressString()}</p>
					</div>
				);
			}

			return (
				<div className={`${className} locked`}>
					<div className="locked-icon">
						<FontAwesomeIcon icon={faClock} />
					</div>
					<p className="small-text">Coming soon</p>
				</div>
			);
		}

		if (state === ModuleStateType.DisabledUpsell) {
			return (
				<div className={`${className} locked`} onClick={handleOpenLockModal}>
					<div className="locked-icon">
						<FontAwesomeIcon icon={faLock} />
					</div>
					<p className="small-text">Locked</p>
				</div>
			);
		}

		if (state === ModuleStateType.CourseTraversal) {
			return (
				<div className={`${className} soft-locked`} onClick={() => handleOpenCourseTraversalModal(ruleType)}>
					<div className="locked-icon">
						<FontAwesomeIcon icon={faLock} />
					</div>
					<p className="small-text">Locked</p>
				</div>
			);
		}

		return null;
	};

	return <>{renderSubmoduleProgress()}</>;
};

export default ProgressIcon;